import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/throw';

import { AuthHttpClient } from '../../../../providers/auth-http.service';

import { default as swal } from 'sweetalert2';


export class SharedExportService {

	public baseUrl: string = '/v1/export';

	constructor(private sHttp: AuthHttpClient) {}

	public getCandidateHackResults(clientId: string, candidateId: string, hackId: string): Observable<any> {
		let url = this.baseUrl + '/auth/client/' + clientId + '/candidate/' + candidateId + '/hack/' + hackId + '/exported_results';
		return this.sHttp.get(url)
			.map(this.extractData)
			.catch(this.handleError);
	}

	private extractData(res: Response) {
		if (res) {
			let resp: any = res;
			if (res.status === 401) {
				window.location.assign(process.env.LANDING_PAGES_URL);
			}
			if (resp._body && resp._body !== '') {
				let body = res.json();
				if (typeof Object.keys(body)[0] !== 'undefined') {
					return body[Object.keys(body)[0]];
				}
			}
			return {};
		}
	}

	private handleError(error: any) {
		let errMsg = (error.message) ? error.message :
		error.status ? `${error.status} - ${error.statusText}` : 'Server error';
		console.error(errMsg);
		swal({
			title: `Oops, there's been an error`,
			text: `Our tech team has been notified, however please email contact@hackajob.co and we'll try and solve the issue as soon as possible. Thanks and sorry for any inconvenience.`,
			type: 'error',
			showCancelButton: false,
			confirmButtonColor: '#008fb3',
			confirmButtonText: 'Ok',
			allowOutsideClick: false,
			allowEscapeKey: false
		});
		return Observable.throw(errMsg);
	}
static ctorParameters() { return [ { type: AuthHttpClient } ]; }}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/client/shared/services/shared-export.service.ts